import { render, staticRenderFns } from "./EmptyState.vue?vue&type=template&id=2b5e8be6&scoped=true&"
import script from "./EmptyState.vue?vue&type=script&lang=js&"
export * from "./EmptyState.vue?vue&type=script&lang=js&"
import style0 from "./EmptyState.vue?vue&type=style&index=0&id=2b5e8be6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5e8be6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b5e8be6')) {
      api.createRecord('2b5e8be6', component.options)
    } else {
      api.reload('2b5e8be6', component.options)
    }
    module.hot.accept("./EmptyState.vue?vue&type=template&id=2b5e8be6&scoped=true&", function () {
      api.rerender('2b5e8be6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/lib/components/ui/EmptyState.vue"
export default component.exports